import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterContentChecked } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { NetworkAndShowsR5Component } from '../network-and-shows-r5/network-and-shows-r5.component';
import * as jQuery from 'jquery';
import { ModalService } from '../../../shared/directives/modal/modal.service';

@Component({
	selector: 'app-screenshots-r5',
	templateUrl: './screenshots-r5.component.html',
	styleUrls: ['./screenshots-r5.component.css']
})
export class ScreenshotsR5Component extends NetworkAndShowsR5Component implements OnInit, AfterContentChecked {
	public screenShotsData;
	@ViewChild('screencarousel') carousel: any;
	public currentScreenshotData;
	hasData = false;
	public carouselLoadFlag = false;
	public options = {
		clicking: true,
		sourceProp: '',
		visible: 7,
		perspective: 1,
		startSlide: 4,
		border: 3,
		dir: 'rtl',
		width: 300,
		height: 250,
		space: 200,
		loop: true,
		autoRotationSpeed: 500000,
		autoRotationLocked: true
	};

	ngAfterContentChecked() {
		// rebuild carousel when there is a change in networks array using the flag `carouselLoadFlag`
		if (this.carousel && this.carouselLoadFlag) {
			this.carousel.currentIndex = this.selectedIndex;
			this.options.startSlide = this.selectedIndex;
			this.carousel.buildCarousel(this.screenShotsData, this.options);
			this.carouselLoadFlag = false;
		}
	}

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected modalService: ModalService
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
	}

	ngOnInit() {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.requestData();
	}

	requestData() {
		this.showLoad = true;
		this.hasData = false;
		this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			this.screenShotsData = [];
			this.showLoad = false;
			if (res.success && res.data.length > 0) {
				this.hasData = true;
				this.processResponseData(res.data);
				this.carouselLoadFlag = true;
			}
		});
	}

	ngAfterViewInit() {
		jQuery('.carouselSlideActive .carouselImg').click();
	}

	processResponseData(responseData: any) {
		for (const response of responseData) {
			const obj = {
				imageURL: response.path,
				date: response.date,
				domainName: response.url
			};
			this.screenShotsData.push(obj);
		}
		this.selectedIndex = this.screenShotsData.length < 7 ? Math.floor(this.screenShotsData.length / 2) : 4;
		this.currentScreenshotData = JSON.parse(JSON.stringify(this.screenShotsData[this.selectedIndex]));
	}

	slideClicked(index) {
		for (let slide in this.carousel.$slides) {
			this.carousel.$slides[slide].className = 'carouselSlide';
		}
		this.carousel.$slides[index].className = 'carouselSlideActive';
		jQuery('.carouselSlideActive .carouselImg .slideMask').css({
			width: '0px',
			height: '0px'
		});
		jQuery('.carouselSlide .carouselImg .slideMask').css({
			width: '100%',
			height: '100%'
		});

		this.carousel.currentIndex = this.screenShotsData.length < 7 ? Math.floor(this.screenShotsData.length / 2) : 4;
		this.carousel.slideClicked(index);
		this.selectedIndex = index;
		this.currentScreenshotData = JSON.parse(JSON.stringify(this.screenShotsData[this.selectedIndex]));
	}

	slideLeft() {
		if (this.selectedIndex === 0) {
			this.selectedIndex = this.screenShotsData.length - 1;
		} else {
			this.selectedIndex--;
		}
		this.slideClicked(this.selectedIndex);
	}

	slideRight() {
		if (this.selectedIndex === this.screenShotsData.length - 1) {
			this.selectedIndex = 0;
		} else {
			this.selectedIndex++;
		}
		this.slideClicked(this.selectedIndex);
	}

	previewScreenshot(imageURL: string) {
		const win = window.open(imageURL, '_blank');
		win.focus();
	}
}
